export default __webpack_public_path__ + "static/media/rangetubeImg_1.c7052abb.png";